import EA from '../helpers/init';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.detailBannerLogic = ($this) => {
    const bannerContainer = $this;
    const bannerCloseBtn = bannerContainer.querySelector('.detail-page-banner-close-btn');

    const inertElements = new Map();
    let previousFocus = null;

    bannerContainer.setAttribute('role', 'dialog');
    bannerContainer.setAttribute('aria-modal', 'true');

    function closeBanner() {
        bannerContainer.classList.remove('shown');

        inertElements.forEach((wasInert, element) => {
            element.inert = wasInert;
        });

        inertElements.clear();

        document.removeEventListener('keydown', trapFocus);

        previousFocus?.focus?.({ preventScroll: true });
    }

    function trapFocus(e) {
        if (e.key === 'Escape') {
            closeBanner();
            return;
        }

        if (e.key !== 'Tab') return;

        const focusable = [...bannerContainer.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )].filter(el => el.getClientRects().length);

        if (!focusable.length) {
            e.preventDefault();
            bannerContainer.setAttribute('tabindex', '-1');
            bannerContainer.focus();
            return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    function openBanner() {
        previousFocus = document.activeElement;

        let element = bannerContainer;

        while (element && element !== document.body) {
            [...element.parentElement.children].forEach(sibling => {
                if (sibling !== element) {
                    inertElements.set(sibling, sibling.inert);
                    sibling.inert = true;
                }
            });

            element = element.parentElement;
        }

        bannerContainer.classList.add('shown');
        bannerCloseBtn.focus();

        document.addEventListener('keydown', trapFocus);
    }

    bannerCloseBtn.addEventListener('click', closeBanner);

    ScrollTrigger.create({
        start: () => ScrollTrigger.maxScroll(window) * 0.4,
        onEnter: self => {
            openBanner();
            self.kill();
        }
    });
};